<template>
  <div class="profile_area">
    <div class="profile_item">
      <p>이메일</p>
      <div>
        <input type="text" v-model="corpInfo.email" disabled />
      </div>
    </div>

    <div class="profile_item">
      <p>휴대폰 번호</p>
      <div class="change_tel_btn_area">
        <input type="text" v-model="corpInfo.corpTel" disabled />
        <div class="change_tel_btn">
          <button @click="changeTel">변경하기</button>
          <div class="dp_none" id="refresh" @click="$emit('openChangeTelComplete')"></div>
        </div>
      </div>
    </div>

    <div class="withdrawal_btn">
      <p @click="openWithdrawal">회원 탈퇴</p>
    </div>
  </div>
</template>

<script>
import { niceCheckPlus } from '@/modules/nice/niceCheckPlus';
import { parentMessage } from '@/utils/message/parentMessage';
export default {
  name: 'settingProfile',
  data() {
    return {
      removeListener: null,
      niceAuth: niceCheckPlus.createState(),
    };
  },
  props: {
    corpInfo: Object,
  },
  mounted() {
    this.removeListener = parentMessage(this.onNiceMessage);
  },
  methods: {
    onNiceMessage(event) {
      niceCheckPlus.handleMessage(this.niceAuth, event);
    },
    async changeTel() {
      try {
        await niceCheckPlus.open(this.niceAuth);
      } catch (error) {
        console.error(`[changeTel ${error}]`);
        alert(error.message);
      }
    },
    openWithdrawal() {
      this.$emit('openWithdrawal');
    },
  },
  watch: {
    'niceAuth.isCheckNice'(newValue) {
      if (newValue) {
        this.$emit('openChangeTelComplete');
      }
    },
  },
  beforeDestroy() {
    this.removeListener?.();
  },
};
</script>

<style scoped>
.profile_area {
  position: relative;
  width: 100%;
  height: 100%;
}
.profile_area .profile_item {
  margin-bottom: 16px;
}
.profile_area .profile_item p {
  margin-bottom: 8px;
  color: hsla(0, 0%, 88.2%, 0.8);
  font-size: 16px;
}
.profile_area .profile_item input {
  width: 100%;
}
.profile_area .profile_item .change_tel_btn_area {
  position: relative;
}
.profile_area .profile_item .change_tel_btn_area .change_tel_btn {
  position: absolute;
  top: 50%;
  right: 1%;
  transform: translate(0, -50%);
}
.profile_area .profile_item .change_tel_btn_area .change_tel_btn button {
  width: 80px;
  height: 40px;
  color: black;
}

.profile_area .withdrawal_btn {
  position: absolute;
  bottom: 0;
  left: 0;
}
.profile_area .withdrawal_btn p {
  color: hsla(0, 0%, 88.2%, 0.8);
  font-size: 16px;
  cursor: pointer;
}
</style>
